import DataStructure, { sanitize } from "./DataStructure.js";
import { deepFreeze } from "../util/misc.js";

export const EMAIL_FIELDS = { address: "", type: "" };
deepFreeze(EMAIL_FIELDS);

export const EMAIL_TYPES = {
  billing: { label: "Billing", icon: "billing" },
  work: { label: "Work", icon: "work" },
  personal: { label: "Personal", icon: "home" },
};
deepFreeze(EMAIL_TYPES);

export const EMAIL_FORMAT =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default class Email extends DataStructure {
  constructor(data = {}) {
    super(sanitize(data, EMAIL_FIELDS));
  }

  // Editing

  get isValid() {
    return Boolean(this.address && EMAIL_FORMAT.test(this.address));
  }

  // Formatting

  get type() {
    return this.data.type
      ? EMAIL_TYPES[this.data.type] || {
          label: this.data.type,
          icon: "",
        }
      : null;
  }

  get link() {
    return this.getLink();
  }

  getLink(subject, body) {
    if (!this.isValid) {
      return "";
    }

    // The first header follows a `?`, the rest an `&` (RFC 6068); with an `&`
    // straight after the address, mail apps read it as part of the address.
    const headers = [];
    if (subject) {
      headers.push("subject=" + encodeURIComponent(subject));
    }
    if (body) {
      headers.push("body=" + encodeURIComponent(body));
    }
    return (
      "mailto:" + this.address + (headers.length ? "?" + headers.join("&") : "")
    );
  }

  toString() {
    return this.address;
  }
}
